import React from "react";

export const FormSection = (props) => {
  return (
    <div className="bg1" style={{ display: "flex", flexDirection: "column" }}>
      {props.children}
    </div>
  );
};
